import './logo.scss';
import React, { useState, useEffect, useContext, useCallback } from 'react';
import { AppContext } from '../../context/appContext';
import If from '../../common/components/if';
import { toHome } from '../../services/authorizationService';
import ImageUtil from '../../common/utils/imageUtil';
import { getLogoStyle } from 'common/src/services/util';
import USELogo from './images/use_logo.png';
export interface IProps {
    trackEvent: string;
    hideDefaultLogo: boolean;
    entry?: VoidFunction;
    onLogoLoaded: VoidFunction;
}

export function Logo(props: IProps) {
    const appContext = useContext(AppContext);
    const state = appContext.state;
    const enterpriseInfo = state.enterpriseInfo;
    const isInUSE = state.isInUSE;
    const [src, setSrc] = useState('');
    const [imgStyle, setImgStyle] = useState({ visibility: 'hidden' } as React.CSSProperties);
    const { entry, trackEvent, hideDefaultLogo, onLogoLoaded } = props;

    const handleLogoLoaded = useCallback(() => {
        if (onLogoLoaded) {
            onLogoLoaded();
        }
    }, [onLogoLoaded]);

    useEffect(() => {
        let src = ImageUtil.process(enterpriseInfo.logo_pc || enterpriseInfo.logo, {});

        if (isInUSE) {
            src = src || USELogo;
        }

        if (!src) {
            return;
        }

        setSrc(src);

        getLogoStyle(src, (style) => {
            setImgStyle(style);
        });
    }, []);

    const handleClickLogo = useCallback(
        (evt: React.MouseEvent<HTMLAnchorElement>) => {
            evt.preventDefault();

            if (entry) {
                entry();
            } else {
                toHome({ logined: true, enterpriseInfo, isInUSE });
            }
        },
        [entry],
    );

    return (
        <div className={`logo`}>
            <a
                className={`page-header-logo ${trackEvent ? 'trackEvent' : ''}`}
                data-track-cat="{{::trackEvent.cat}}"
                data-track-label="{{::trackEvent.label}}"
                href="#"
                onClick={handleClickLogo}
            >
                <If condition={!!src}>
                    <img src={src} alt="" className={`custom-logo`} onLoad={handleLogoLoaded} style={imgStyle} />
                </If>
                <If condition={!src && !hideDefaultLogo}>
                    <div className="img"></div>
                </If>
            </a>
        </div>
    );
}
